export const categoryItems = [
  { title: "", value: "" },
  { title: "出席簿(日次)", value: "attendance" },
  { title: "出席簿(月次)", value: "attendanceSummary" },
  { title: "クラス日誌", value: "classDiary" },
  { title: "午睡", value: "nap" },
  { title: "成長記録", value: "growth" },
  { title: "月次スタッフ予定", value: "shiftPatternMonthly" },
  { title: "日次スタッフ予定", value: "shiftPatternDaily" },
  { title: "発達記録表", value: "childDevelopment" },
  { title: "経過記録", value: "childDevelopmentRecord" },
  { title: "VEVOレポート", value: "childDevelopmentAiReport" },
  { title: "指導計画", value: "teachingPlan" },
];

export const statusItems = [
  { title: "", value: "" },
  { title: "完了", value: "completed" },
  { title: "処理中", value: "inProgress" },
  { title: "タイムアウト", value: "timeout" },
  { title: "失敗", value: "failed" },
];
